// TRIAL_MCP: the 14-day Risika for AI trial (ENG2-2614 / parent ENG2-2553).
//
// RisikaAPI owns the defaults: the template gives 200 unique Nordic lookups,
// and on creation with, or a plan change to, TRIAL_MCP the API sets allow_ai
// true and rights.global.ai_end_date = today + 14 (any other plan change
// clears the date). CMD never sends these; it shows them so CS sees what the
// API will store before confirming, and re-fetches the customer afterwards.

import moment from 'moment'

export const TRIAL_MCP_PLAN = 'TRIAL_MCP'

export const TRIAL_MCP_DEFAULTS = {
  lookups: 200,
  allow_ai: true,
  trial_days: 14,
} as const

// ISO date (YYYY-MM-DD) the API stores as ai_end_date for a TRIAL_MCP
// customer created or moved on `today`.
export const trialMcpEndDate = (today: Date = new Date()): string =>
  moment(today).add(TRIAL_MCP_DEFAULTS.trial_days, 'days').format('YYYY-MM-DD')

// The defaults the API applies on its own for a plan, as one line for CS, or
// null when the plan has none worth calling out.
export const packageDefaultsNote = (
  plan: string | undefined | null,
  today: Date = new Date(),
): string | null => {
  if (plan !== TRIAL_MCP_PLAN) return null
  const ends = moment(trialMcpEndDate(today), 'YYYY-MM-DD').format('DD.MM.YYYY')
  return `Trial-MCP: ${TRIAL_MCP_DEFAULTS.lookups} Nordic lookups, Risika for AI on until ${ends} (${TRIAL_MCP_DEFAULTS.trial_days} days).`
}
